import React, { useState, useEffect, useRef } from 'react';
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';


export default function Logout(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        var user = util.getCurrentUser();
        if(user == null){
            util.clearCurrentUser();
            console.log("logout done in user null");
            if(props.onLoggedOut)props.onLoggedOut();
            setRedirectUrl("/login");
        }
        else{
            var params = {
                login:util.getLoginDto()
            };
            var url = config.Server+`/user/logout`;
            console.log("params is>", params);
            console.log("url is>", url);
            axios
                .post(url, params )
                .then(res => {
                    console.log("logout done in main");
                    util.clearCurrentUser();
                    if(props.onLoggedOut)props.onLoggedOut();
                    setRedirectUrl("/login");
                })
                .catch(error => {
                    console.log("logout done in error");
                    setRedirectUrl("/login");
                });

        }
    }, []);
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        <>
        </>
    )
}